/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { EvidenceExportGipReportMutationRequest, EvidenceExportGipReportMutationResponse, EvidenceExportGipReportPathParams, EvidenceExportGipReport400, EvidenceExportGipReport404 } from "../models/EvidenceExportGipReport";

export function getEvidenceExportGipReportUrl(id: EvidenceExportGipReportPathParams["id"]) {
  const res = { method: 'POST', url: `/reports/gip/report/${id}/evidence-export` as const }
  return res
}

/**
 * @summary Start evidence export
 * {@link /reports/gip/report/:id/evidence-export}
 */
export async function evidenceExportGipReport(id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest, config: Partial<RequestConfig<EvidenceExportGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, EvidenceExportGipReportMutationRequest>({ method : "POST", url : getEvidenceExportGipReportUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}